import classnames from 'classnames'
import { ButtonLink } from '@components/ui/Button'
import { ButtonVariant } from '@components/ui/Button/Button'
import { getAnalyticsCountryCode } from '@helpers/env'
import MediaItem from '@components/ui/Medias/MediaItem'
import { analytics } from '@helpers/analytics'
import { jsonToArray } from '@helpers/contentful'
import { Button } from 'types/contentful'
import styles from './styles.module.scss'
import { StatementSectionProps } from 'types/contentful/graphQlApi'

const StatementSection = ({
  title,
  underTitle,
  copy,
  media,
  button,
  buttons,
  greyBackground,
  rootPath,
  firstTimeUser
}: StatementSectionProps & {
  sectionClasses?: string
}) => {
  const handleLinkClicked = ({ event }: { event?: Button['event'] }) => {
    if (!event) return

    const type = rootPath ? { type: firstTimeUser ? 'New' : 'Existing' } : {}
    analytics('Click', {
      ...event,
      store_location: getAnalyticsCountryCode(),
      ...type
    })
  }

  const statementClasses = classnames(
    styles.statement,
    styles.statement_staticHeader,
    {
      [styles.statement__grey]: greyBackground
    }
  )

  const scrollToHash = (mediaRef: HTMLElement | null) => {
    const urlHash = global.window.location.href.split('#')[1] || ''

    if (mediaRef?.getAttribute('data-id') === urlHash) {
      setTimeout(() => {
        mediaRef.scrollIntoView({ behavior: 'smooth' })
      }, 1000)
    }
  }

  return (
    <div
      ref={ref => scrollToHash(ref)}
      className={statementClasses}
      data-id={`${media ? 'media' : 'statement'}`}
    >
      <div className={styles.statement__container}>
        {title && <h2 className={styles.statement__title}>{title}</h2>}

        {underTitle && (
          <p className={styles.statement__subtitle}>{underTitle}</p>
        )}
        {copy && (
          <p
            className={`${
              underTitle ? styles.statement__byline : styles.statement__copy
            }`}
          >
            {copy}
          </p>
        )}
        {button && (
          <ButtonLink
            variant={(button?.buttonStyle as ButtonVariant) || 'secondary'}
            onClick={() => handleLinkClicked(button)}
            href={button.uri}
          >
            {button.text}
          </ButtonLink>
        )}
        {!!jsonToArray(buttons || {}).length && (
          <div className="grid grid--gutter grid--horizontal-center statement__buttons__container">
            <div className="grid__container">
              {jsonToArray(buttons || {}).map((button, i) => (
                <ButtonLink
                  key={i.toString()}
                  classes={styles.statement__button__item}
                  variant={button.buttonStyle || 'secondary'}
                  onClick={() => handleLinkClicked(button)}
                  href={button.uri}
                >
                  {button.text}
                </ButtonLink>
              ))}
            </div>
          </div>
        )}
        {media && (
          <div className={styles.statement__media}>
            <MediaItem {...media} />
          </div>
        )}
      </div>
    </div>
  )
}

export default StatementSection
